import { instacarAppLanguageSchema } from "@instacover/helpers"

import type { InstacarAppLanguage } from "@/utils/types"

/** Every language the app ships locale files for, in the order the Prisma enum declares them. */
export const ALL_APP_LANGUAGES: readonly InstacarAppLanguage[] = instacarAppLanguageSchema.options

// Browsers still send the legacy ISO code for Georgian, the app uses "ka"
const LEGACY_LANGUAGE_ALIASES: Record<string, InstacarAppLanguage> = { ge: "ka" }

// Matches i18n's fallbackLng, which is the only bundle guaranteed to be present
const FALLBACK_LANGUAGE: InstacarAppLanguage = "cs"

/** Narrows any i18next language string to one the app ships locale files for. */
export function resolveAppLanguage(value: string): InstacarAppLanguage {
  return toAppLanguage(value) ?? FALLBACK_LANGUAGE
}

function toAppLanguage(value: string): InstacarAppLanguage | undefined {
  // "sk-SK" -> "sk"
  const [primarySubtag] = value.toLowerCase().split("-")
  const parsed = instacarAppLanguageSchema.safeParse(LEGACY_LANGUAGE_ALIASES[primarySubtag] ?? primarySubtag)

  return parsed.success ? parsed.data : undefined
}

/**
 * Language for screens rendered without a session, where no customer configuration says which
 * languages are offered. Picks the first browser preference the app has translations for.
 */
export function detectBrowserLanguage(): InstacarAppLanguage {
  for (const preference of [...(navigator.languages ?? []), navigator.language]) {
    const language = toAppLanguage(preference)

    if (language) return language
  }

  return FALLBACK_LANGUAGE
}
